<template>
  <div>
    <v-client-table :data="data.agences" :columns="columns" :options="options">
      <div slot="adresse" slot-scope="props">
        {{ importedFunction.adressFullStringGetter(props.row.adresse) }}
      </div>
      <div slot="type">
        {{ $t('societes.agence') }}
      </div>
      <div slot="edit" class="has-text-centered" slot-scope="props">
        <a @click="checkPermissions(permSocietes.maj) ?
        $router.push({name: 'm.parametrage.societe/agence-modificationAgence',
        params: { societeId: data.id, agenceId: props.row.id}})
        : showPopUp()">
          <b-icon icon="pencil-box-outline" type="is-success"
                  :class="{'text-access-no-permission' : !checkPermissions(permSocietes.maj)}">
          </b-icon>
        </a>
      </div>
      <div slot="archivage" class="has-text-centered">
        <a @click="checkPermissions(permSocietes.supprimer) ? inProgress() : showPopUp()">
          <b-icon icon="archive" type="is-primary" :class="{
                'text-access-no-permission' : !checkPermissions(permSocietes.supprimer)
                }">
          </b-icon>
        </a>
      </div>
      <div slot="delete" slot-scope="" class="has-text-centered">
        <a @click="checkPermissions(permSocietes.supprimer) ? inProgress() : showPopUp()">
          <b-icon icon="delete-forever" type="is-danger"
                  :class="{
                'text-access-no-permission' : !checkPermissions(permSocietes.supprimer)
                }"
          ></b-icon>
        </a>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { TEXTS, SORT_ICON } from '@/configuration/clientTableConf';
import { SOCIETES } from '@/configuration/general/permissionsParametrageConf';
import inProgress from '@/services/general/inProgress';

const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'childRowSociete',
  props: {
    data: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      permSocietes: SOCIETES,
      importedFunction: {
        adressFullStringGetter,
      },
    };
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    columns() {
      return ['codeAgence', 'libelle', 'type', 'adresse', 'telephone', 'edit', 'archivage', 'delete'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          codeAgence: this.$t('societes.code'),
          libelle: this.$t('societes.libelle'),
          type: this.$t('societes.type'),
          adresse: this.$t('societes.adresse'),
          telephone: this.$t('societes.tel'),
          edit: '',
          archivage: '',
          delete: '',
        },
        texts: texts,
        filterable: false,
        columnsClasses: {
          selected: 'colonneSelected',
        },
        sortable: ['codeAgence', 'libelle', 'type', 'adresse', 'telephone'],
      };
    },
  },
};
</script>

<style scoped>

</style>
